import { render, staticRenderFns } from "./ConfiguracaoMeioPagamentoHeader.vue?vue&type=template&id=330f7fe2"
import script from "./ConfiguracaoMeioPagamentoHeader.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoMeioPagamentoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports